import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MlEvaluationQueryDto, MlEvaluationSummaryDto } from '../../../_core/_model/machine-learning';
import { MachineLearningAdminService } from '../../../_core/_services/machine-learning-admin.service';
import { AuthService } from '../../../_core/_services/auth.service';
import { mlPredictionTypesForRole } from '../../../_core/_model/user-role';

@Component({
  selector: 'app-admin-ml-evaluation',
  standalone: false,
  templateUrl: './admin-ml-evaluation.html',
  styleUrl: './admin-ml-evaluation.css'
})
export class AdminMlEvaluation implements OnInit {
  loading = false;
  error = '';
  summary: MlEvaluationSummaryDto | null = null;
  query: MlEvaluationQueryDto = { predictionType: null };
  predictionTypes: string[] = [];

  constructor(
    private mlService: MachineLearningAdminService,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    this.auth.getCurrentUser().subscribe(user => {
      this.predictionTypes = mlPredictionTypesForRole(user?.role);
      this.query.predictionType = this.predictionTypes[0] ?? null;
      this.load();
    });
  }

  load(): void {
    this.loading = true;
    this.error = '';
    this.mlService.getEvaluationSummary(this.query).subscribe({
      next: response => {
        this.summary = response.data;
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.error = error.error?.error?.details || error.error?.message || error.message || 'Unable to load model evaluation.';
        this.loading = false;
      }
    });
  }

  badgeClass(value?: string | null): string {
    switch ((value || '').toLowerCase()) {
      case 'low': case 'confirmednormal': return 'text-bg-success';
      case 'moderate': case 'inconclusive': return 'text-bg-warning text-dark';
      case 'high': case 'falsepositive': case 'falsenegative': return 'text-bg-danger';
      case 'critical': case 'confirmedsuspicious': case 'confirmedaccounttakeover': return 'text-bg-dark';
      default: return 'text-bg-light text-dark border';
    }
  }

  width(value?: number | null): string {
    const safe = Math.max(0, Math.min(100, Number(value) || 0));
    return `${safe}%`;
  }
}
